import { createContext, useContext, useEffect, useState, useCallback } from 'react'
import { api, setToken, getToken } from './api.js'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  const loadMe = useCallback(async () => {
    if (!getToken()) { setUser(null); setLoading(false); return }
    try {
      const { data } = await api.get('/auth/me')
      setUser(data.user)
    } catch {
      setToken(null); setUser(null)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { loadMe() }, [loadMe])

  const login = async (login, password) => {
    const { data } = await api.post('/auth/login', { login, password })
    setToken(data.token)
    setUser(data.user)
    return data.user
  }

  const logout = async () => {
    try { await api.post('/auth/logout') } catch {}
    setToken(null); setUser(null)
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  return useContext(AuthContext)
}

export function hasRole(user, ...roles) {
  return user?.roles?.some((r) => roles.includes(r))
}
export function hasAnyRole(user) {
  return (roles) => user?.roles?.some((r) => roles.includes(r))
}
